import React from "react";
import { Link } from "react-router-dom";

export default ({ path = "", left = "", submit }) => {
  return (
    <div>
      {path && (
        <Link className="btn btn-default" to={path}>
          <i className="fa fa-angle-left" /> &nbsp;{left}
        </Link>
      )}
      {path && <span>|</span>}
      <button type="submit" className="btn btn-primary">
        {submit}&nbsp; <i className="fa fa-angle-right" />
      </button>
    </div>
  );
};
